/**
 * GDPR cookie consent — categorized.
 * Stores object { functional, analytics, marketing, ts } in localStorage.richard_cookie_consent.
 * Migrates legacy 'all'/'rejected' string values on read.
 *
 * Public API: window.RichardConsent
 *   .has(category)   → bool, where category in {'functional','analytics','marketing'}
 *   .acceptAll()     → grant all
 *   .rejectAll()     → reject all (functional always true — strictly necessary)
 *   .set(prefs)      → merge partial prefs and persist
 *   .raw()           → object | null
 */
(function () {
  var STORAGE_KEY = 'richard_cookie_consent';
  var DEFAULT_REJECTED = { functional: true, analytics: false, marketing: false };
  var ALL_ACCEPTED    = { functional: true, analytics: true,  marketing: true  };

  function readRaw() {
    try { return localStorage.getItem(STORAGE_KEY); }
    catch (_) { return null; }
  }

  function read() {
    var raw = readRaw();
    if (!raw) return null;
    // Legacy string values
    if (raw === 'all') return ALL_ACCEPTED;
    if (raw === 'rejected') return DEFAULT_REJECTED;
    try {
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (_) {}
    return null;
  }

  function write(prefs) {
    var merged = Object.assign({}, DEFAULT_REJECTED, prefs, { ts: Date.now() });
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(merged)); } catch (_) {}
    document.body.dispatchEvent(new CustomEvent('cookie:consent', {
      detail: { prefs: merged },
      bubbles: true
    }));
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(!!merged.analytics, function () {});
      } catch (_) {}
    }
    return merged;
  }

  // Public API — available immediately, before banner DOM exists.
  window.RichardConsent = {
    has: function (category) {
      var v = read();
      if (!v) return false;
      return v[category] === true;
    },
    raw: function () { return read(); },
    acceptAll: function () { return write(ALL_ACCEPTED); },
    rejectAll: function () { return write(DEFAULT_REJECTED); },
    set: function (prefs) {
      var current = read() || DEFAULT_REJECTED;
      return write(Object.assign({}, current, prefs));
    }
  };

  // Banner + modal UI binding
  var banner = document.querySelector('[data-cookie-consent]');
  var modal  = document.querySelector('[data-cookie-modal]');
  if (!banner) return;

  if (!read()) {
    banner.hidden = false;
    document.body.classList.add('cookie-consent-open');
  }

  function dismissBanner() {
    banner.hidden = true;
    document.body.classList.remove('cookie-consent-open');
  }

  // Focus trap state
  var modalPreviouslyFocused = null;
  var modalTrapHandler = null;

  function trapModalFocus() {
    modalPreviouslyFocused = document.activeElement;
    modalTrapHandler = function (e) {
      if (e.key !== 'Tab' || !modal) return;
      var focusables = modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', modalTrapHandler);
    var closeBtn = modal.querySelector('[data-cookie-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function releaseModalFocus() {
    if (modalTrapHandler) {
      document.removeEventListener('keydown', modalTrapHandler);
      modalTrapHandler = null;
    }
    if (modalPreviouslyFocused && typeof modalPreviouslyFocused.focus === 'function') {
      modalPreviouslyFocused.focus();
    }
    modalPreviouslyFocused = null;
  }

  function openModal() {
    if (!modal) return;
    var prefs = read() || DEFAULT_REJECTED;
    modal.querySelectorAll('[data-cookie-pref]').forEach(function (input) {
      var key = input.dataset.cookiePref;
      if (key === 'functional') return; // always on, disabled
      input.checked = !!prefs[key];
    });
    modal.hidden = false;
    document.body.classList.add('cookie-modal-open');
    trapModalFocus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('cookie-modal-open');
    releaseModalFocus();
  }

  function readModalPrefs() {
    var prefs = {};
    modal.querySelectorAll('[data-cookie-pref]').forEach(function (input) {
      prefs[input.dataset.cookiePref] = input.checked;
    });
    prefs.functional = true;
    return prefs;
  }

  // Banner buttons
  var acceptBtn = banner.querySelector('[data-cookie-accept]');
  var rejectBtn = banner.querySelector('[data-cookie-reject]');
  var customizeBtn = banner.querySelector('[data-cookie-customize]');
  if (acceptBtn)    acceptBtn.addEventListener('click',    function () { window.RichardConsent.acceptAll(); dismissBanner(); });
  if (rejectBtn)    rejectBtn.addEventListener('click',    function () { window.RichardConsent.rejectAll(); dismissBanner(); });
  if (customizeBtn) customizeBtn.addEventListener('click', function () { openModal(); });

  // Modal buttons
  if (modal) {
    var saveBtn         = modal.querySelector('[data-cookie-save]');
    var modalRejectBtn  = modal.querySelector('[data-cookie-reject]');
    var modalCloseBtns  = modal.querySelectorAll('[data-cookie-modal-close]');

    if (saveBtn) saveBtn.addEventListener('click', function () {
      window.RichardConsent.set(readModalPrefs());
      closeModal();
      dismissBanner();
    });
    if (modalRejectBtn) modalRejectBtn.addEventListener('click', function () {
      window.RichardConsent.rejectAll();
      closeModal();
      dismissBanner();
    });
    modalCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }
})();
